<template>
  <div id="app">
    <b-loading :is-full-page="true" :active.sync="isLoading"></b-loading>
    <div class="container is-fluid">
      <NavBar />
      <div class="main-content">
        <div class="centered-hero-forms" v-if="!isLoggedIn">
            <SignInForm v-if="!isRegisterPath" />
            <Register v-if="!!isRegisterPath"  />
        </div>
        <router-view v-show="isLoggedIn"/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import SignInForm from '@/components/SignInForm.vue';
import NavBar from '@/components/NavBar.vue';
import Register from '@/components/RegisterForm.vue';
import ApiUtil from '@/utils/ApiUtil';

export default {
  components: {
    SignInForm,
    Register,
    NavBar,
  },
  async mounted() {
    if (!this.isLoggedIn && !this.isRegisterPath) this.$router.push({ name: 'sign-in' });
    if (this.isLoggedIn) {
      const userInfo = await ApiUtil.getUserInfo();
      this.setUserContext(userInfo);
    }
  },
  computed: {
    ...mapState([
      'isLoggedIn',
      'isLoading',
      'user',
    ]),
    isRegisterPath() { return this.$route.path === '/register'; },
  },
  methods: {
    ...mapMutations([
      'logOut',
      'setUserContext',
    ]),
  },
};
</script>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
header.navbar.has-shadow {
  box-shadow: 0 2px 0 0 #e2e2e2;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.container {
  margin-top: 30px;
  margin-left: 15px;
  margin-right: 15px;
}

.main-content {
  margin-top: 20px;
  margin-bottom: 50px;
}

.centered-hero-forms {
  max-width: 500px;
  margin: auto;
  padding-left: 15px;
  padding-right: 15px;
}

.field.is-grouped {
  .field {
    margin-left: 0 !important;
    margin-right: 0.75rem;
  }
  .field:last-child {
    margin-bottom: 0.75rem;
  }
}

main {
  // text-align: center;
}
</style>
